export enum LevelLog {
  INFO = 'info',
  ERROR = 'error'
}
